export interface FAQItem {
  id: string
  question: string
  answer: string
  image: string
}

export interface ShirtPrintingPlayer {
  id: string
  name: string
}

export const SHIRT_PRINTING_FAQ_ITEMS: FAQItem[] = [
  {
    id: 'printing-styles',
    question: 'What printing styles do you have?',
    answer:
      'We have all the latest styles for all the major club and international teams. We have the current Premiership, La Liga, Serie A, SPL, Bundesliga, Ligue 1, Eredivise, Super Liga and MLS prints, as well as the latest Nike, Puma, Adidas, Umbro and Kappa international name and numbers. We also have club specific prints for all the major teams including Barcelona, Real Madrid, Inter Milan, Juventus and more.',
    image: '/images/shirt-printing/francesco-totti-roma-home-shirt-2009-10.jpg',
  },
  {
    id: 'how-to-order',
    question: 'How do I order a printed shirt?',
    answer:
      "You can find a wide range of pre-printed football shirts for all your favourite stars such as Beckham, Arshavin, Kaka, Ronaldo, Aguero, Rooney, Gerrard, Lampard, Torres and hundreds more stars in our hero shirts section. Alternatively, all our shirts come with the option to add a custom name and number to them. When you see a 'Name and Number' Box on the product page, simply add your desired name and number in the following format - GERRARD 4 and we will print your shirt in the correct printing style.",
    image: '/images/shirt-printing/messi_barcelona_home_shirt_0910.jpg',
  },
  {
    id: 'existing-shirt-order',
    question: 'Can I order printing for a shirt I already own?',
    answer:
      'Yes of course, we are more than happy to send the prints to you. All shirt printing done by UKSoccershop is professionally applied using a special function heat transfer press, however it is also possible to apply the prints with a domestic iron. UKSoccershop take no responsibility for DIY shirt printing, except in the event that the prints are found to be faulty.',
    image: '/images/shirt-printing/fernando-torres-liverpool-away-shirt-2009-10.jpg',
  },
  {
    id: 'send-existing-shirt',
    question: 'Can I send my existing shirt to you for printing?',
    answer:
      'We are happy to print shirts you send to us for printing. The cost of this service is £20 per shirt and this includes your return postage. Before sending your shirt to us, please ensure that the shirt is washed. If you are sending in an older shirt or a shirt that is not one of the more common teams, please check with our team that we have the correct printing.',
    image: '/images/shirt-printing/alexandre-pato.jpg',
  },
  {
    id: 'sleeve-patch',
    question: 'Sleeve Patch',
    answer:
      'In addition to our football shirt printing services, we also offer a range of sleeve patches including UEFA Champions League, Premiership, Bundesliga, La Liga, Serie A and Ligue 1. We also provide club specific badges such as Serie A Scudetto patch, Premier League Champions badge as well as the Champions League winners patches.',
    image: '/images/shirt-printing/sleeve-patch.jpg',
  },
]

/** Featured players in the circular carousel — uses the exact reference images */
export const SHIRT_PRINTING_FEATURED_PLAYERS = [
  { id: 'lionel-messi', name: 'Lionel Messi', image: '/images/shirt-printing/lm.jpg', href: '/results/Messi' },
  { id: 'cristiano-ronaldo', name: 'Cristiano Ronaldo', image: '/images/shirt-printing/cr.jpg', href: '/results/Ronaldo' },
  { id: 'robert-lewandowski', name: 'Robert Lewandowski', image: '/images/shirt-printing/rl.jpg', href: '/results/Lewandowski' },
  { id: 'neymar-jr', name: 'Neymar Jr.', image: '/images/shirt-printing/nj.jpg', href: '/results/Neymar' },
  { id: 'kevin-de-bruyne', name: 'Kevin De Bruyne', image: '/images/shirt-printing/kdb.jpg', href: '/results/De Bruyne' },
  { id: 'kylian-mbappe', name: 'Kylian Mbappé', image: '/images/shirt-printing/km.jpg', href: '/results/Mbappe' },
  { id: 'erling-haaland', name: 'Erling Haaland', image: '/images/shirt-printing/eh.jpg', href: '/results/Haaland' },
  { id: 'mohamed-salah', name: 'Mohamed Salah', image: '/images/shirt-printing/ms.jpg', href: '/results/Salah' },
  { id: 'harry-kane', name: 'Harry Kane', image: '/images/shirt-printing/hk.jpg', href: '/results/Kane' },
  { id: 'jan-oblak', name: 'Jan Oblak', image: '/images/shirt-printing/jo.jpg', href: '/results/Oblak' },
]

/** A-Z player index — exact names from the reference site */
export const SHIRT_PRINTING_PLAYERS_AZ: Record<string, ShirtPrintingPlayer[]> = {
  A: [
    { id: 'aaron-ramsey', name: 'Aaron Ramsey' },
    { id: 'aaron-wan-bissaka', name: 'Aaron Wan Bissaka' },
    { id: 'abdukodir-khusanov', name: 'Abdukodir Khusanov' },
    { id: 'abner', name: 'Abner' },
    { id: 'achraf-hakimi', name: 'Achraf Hakimi' },
    { id: 'adam-armstrong', name: 'Adam Armstrong' },
    { id: 'adam-aznou', name: 'Adam Aznou' },
    { id: 'adam-idah', name: 'Adam Idah' },
    { id: 'adam-wharton', name: 'Adam Wharton' },
    { id: 'adama-traore', name: 'Adama Traore' },
    { id: 'adryelson', name: 'Adryelson' },
    { id: 'ainsley-maitland-niles', name: 'Ainsley Maitland-Niles' },
    { id: 'alan-browne', name: 'Alan Browne' },
    { id: 'alan-shearer', name: 'Alan Shearer' },
    { id: 'alberto-costa', name: 'Alberto Costa' },
    { id: 'alejandro-balde', name: 'Alejandro Balde' },
    { id: 'alejandro-garnacho', name: 'Alejandro Garnacho' },
    { id: 'aleksandar-mitrovic', name: 'Aleksandar Mitrovic' },
    { id: 'alessandro-bastoni', name: 'Alessandro Bastoni' },
    { id: 'alessandro-del-piero', name: 'Alessandro Del Piero' },
    { id: 'alessia-russo', name: 'Alessia Russo' },
    { id: 'alex-greenwood', name: 'Alex Greenwood' },
    { id: 'alex-iwobi', name: 'Alex Iwobi' },
    { id: 'alex-morgan', name: 'Alex Morgan' },
    { id: 'alexander-isak', name: 'Alexander Isak' },
    { id: 'alexander-sorloth', name: 'Alexander Sorloth' },
    { id: 'alexandre-lacazette', name: 'Alexandre Lacazette' },
    { id: 'alexia-putellas', name: 'Alexia Putellas' },
    { id: 'alexis-mac-allister', name: 'Alexis Mac Allister' },
    { id: 'alexis-sanchez', name: 'Alexis Sanchez' },
    { id: 'alfredo-di-stefano', name: 'Alfredo Di Stefano' },
    { id: 'alisha-lehmann', name: 'Alisha Lehmann' },
    { id: 'alisson-becker', name: 'Alisson Becker' },
    { id: 'alphonso-davies', name: 'Alphonso Davies' },
    { id: 'alvaro-morata', name: 'Alvaro Morata' },
    { id: 'amadou-onana', name: 'Amadou Onana' },
    { id: 'andre-onana', name: 'Andre Onana' },
    { id: 'andrea-pirlo', name: 'Andrea Pirlo' },
    { id: 'andreas-christensen', name: 'Andreas Christensen' },
    { id: 'andres-iniesta', name: 'Andres Iniesta' },
    { id: 'andrew-robertson', name: 'Andrew Robertson' },
    { id: 'angel-di-maria', name: 'Angel Di Maria' },
    { id: 'anthony-gordon', name: 'Anthony Gordon' },
    { id: 'antoine-griezmann', name: 'Antoine Griezmann' },
    { id: 'antonio-rudiger', name: 'Antonio Rudiger' },
    { id: 'arda-guler', name: 'Arda Guler' },
    { id: 'arjen-robben', name: 'Arjen Robben' },
    { id: 'arshavin', name: 'Arshavin' },
    { id: 'arturo-vidal', name: 'Arturo Vidal' },
    { id: 'ashley-cole', name: 'Ashley Cole' },
    { id: 'aurelien-tchouameni', name: 'Aurelien Tchouameni' },
  ],
  B: [
    { id: 'bernardo-silva', name: 'Bernardo Silva' },
    { id: 'bukayo-saka', name: 'Bukayo Saka' },
    { id: 'bruno-fernandes', name: 'Bruno Fernandes' },
    { id: 'jude-bellingham', name: 'Jude Bellingham' },
    { id: 'baptiste-santamaria', name: 'Baptiste Santamaria' },
    { id: 'ben-white', name: 'Ben White' },
    { id: 'bobby-decordova-reid', name: 'Bobby Decordova-Reid' },
    { id: 'brahim-diaz', name: 'Brahim Diaz' },
  ],
  C: [
    { id: 'callum-wilson', name: 'Callum Wilson' },
    { id: 'casemiro', name: 'Casemiro' },
    { id: 'cristiano-ronaldo', name: 'Cristiano Ronaldo' },
    { id: 'cesar-azpilicueta', name: 'Cesar Azpilicueta' },
    { id: 'cody-gakpo', name: 'Cody Gakpo' },
    { id: 'cole-palmer', name: 'Cole Palmer' },
    { id: 'conor-gallagher', name: 'Conor Gallagher' },
  ],
  D: [
    { id: 'david-de-gea', name: 'David de Gea' },
    { id: 'declan-rice', name: 'Declan Rice' },
    { id: 'diogo-jota', name: 'Diogo Jota' },
    { id: 'dani-olmo', name: 'Dani Olmo' },
    { id: 'darwin-nunez', name: 'Darwin Nunez' },
    { id: 'dominic-solanke', name: 'Dominic Solanke' },
  ],
  E: [
    { id: 'ederson', name: 'Ederson' },
    { id: 'emile-smith-rowe', name: 'Emile Smith Rowe' },
    { id: 'erling-haaland', name: 'Erling Haaland' },
    { id: 'enzo-fernandez', name: 'Enzo Fernandez' },
    { id: 'evan-ndicka', name: 'Evan Ndicka' },
  ],
  F: [
    { id: 'fabinho', name: 'Fabinho' },
    { id: 'federico-chiesa', name: 'Federico Chiesa' },
    { id: 'ferran-torres', name: 'Ferran Torres' },
    { id: 'florian-wirtz', name: 'Florian Wirtz' },
    { id: 'frank-lampard', name: 'Frank Lampard' },
  ],
  G: [
    { id: 'gareth-bale', name: 'Gareth Bale' },
    { id: 'gavi', name: 'Gavi' },
    { id: 'granit-xhaka', name: 'Granit Xhaka' },
    { id: 'gabriel-martinelli', name: 'Gabriel Martinelli' },
    { id: 'george-baldock', name: 'George Baldock' },
  ],
  H: [
    { id: 'harry-kane', name: 'Harry Kane' },
    { id: 'heung-min-son', name: 'Son Heung-min' },
    { id: 'hugo-lloris', name: 'Hugo Lloris' },
    { id: 'harvey-elliott', name: 'Harvey Elliott' },
  ],
  I: [
    { id: 'ivan-perisic', name: 'Ivan Perisic' },
    { id: 'ibrahimovic', name: 'Zlatan Ibrahimovic' },
    { id: 'ibrahim-sangare', name: 'Ibrahim Sangare' },
  ],
  J: [
    { id: 'jack-grealish', name: 'Jack Grealish' },
    { id: 'jan-oblak', name: 'Jan Oblak' },
    { id: 'joao-cancelo', name: 'Joao Cancelo' },
    { id: 'jordan-henderson', name: 'Jordan Henderson' },
    { id: 'jude-bellingham', name: 'Jude Bellingham' },
    { id: 'jarrod-bowen', name: 'Jarrod Bowen' },
  ],
  K: [
    { id: 'kai-havertz', name: 'Kai Havertz' },
    { id: 'karim-benzema', name: 'Karim Benzema' },
    { id: 'kevin-de-bruyne', name: 'Kevin De Bruyne' },
    { id: 'kylian-mbappe', name: 'Kylian Mbappé' },
    { id: 'kieran-tierney', name: 'Kieran Tierney' },
  ],
  L: [
    { id: 'leroy-sane', name: 'Leroy Sane' },
    { id: 'lionel-messi', name: 'Lionel Messi' },
    { id: 'luka-modric', name: 'Luka Modric' },
    { id: 'luis-diaz', name: 'Luis Diaz' },
    { id: 'lamine-yamal', name: 'Lamine Yamal' },
    { id: 'leandro-trossard', name: 'Leandro Trossard' },
  ],
  M: [
    { id: 'marcus-rashford', name: 'Marcus Rashford' },
    { id: 'martin-odegaard', name: 'Martin Odegaard' },
    { id: 'mason-mount', name: 'Mason Mount' },
    { id: 'mohamed-salah', name: 'Mohamed Salah' },
    { id: 'michael-olise', name: 'Michael Olise' },
    { id: 'milkiyas-miroslav', name: 'Milan Skriniar' },
  ],
  N: [
    { id: 'neymar-jr', name: 'Neymar Jr.' },
    { id: 'nico-williams', name: 'Nico Williams' },
    { id: 'nicolas-jackson', name: 'Nicolas Jackson' },
    { id: 'noni-madueke', name: 'Noni Madueke' },
  ],
  O: [
    { id: 'ousmane-dembele', name: 'Ousmane Dembele' },
    { id: 'oliver-giroud', name: 'Oliver Giroud' },
    { id: 'ollie-watkins', name: 'Ollie Watkins' },
  ],
  P: [
    { id: 'pedri', name: 'Pedri' },
    { id: 'phil-foden', name: 'Phil Foden' },
    { id: 'pierre-emerick-aubameyang', name: 'Pierre-Emerick Aubameyang' },
    { id: 'pedro-neto', name: 'Pedro Neto' },
  ],
  Q: [
    { id: 'quincy-promes', name: 'Quincy Promes' },
  ],
  R: [
    { id: 'rafael-leao', name: 'Rafael Leao' },
    { id: 'reece-james', name: 'Reece James' },
    { id: 'robert-lewandowski', name: 'Robert Lewandowski' },
    { id: 'rodri', name: 'Rodri' },
    { id: 'romelu-lukaku', name: 'Romelu Lukaku' },
    { id: 'ruben-dias', name: 'Ruben Dias' },
  ],
  S: [
    { id: 'sadio-mane', name: 'Sadio Mane' },
    { id: 'sergio-ramos', name: 'Sergio Ramos' },
    { id: 'son-heung-min', name: 'Son Heung-min' },
    { id: 'saka-bukayo', name: 'Bukayo Saka' },
    { id: 'scott-mctominay', name: 'Scott McTominay' },
  ],
  T: [
    { id: 'thiago-alcantara', name: 'Thiago Alcantara' },
    { id: 'toni-kroos', name: 'Toni Kroos' },
    { id: 'trent-alexander-arnold', name: 'Trent Alexander-Arnold' },
    { id: 'tyler-dibling', name: 'Tyler Dibling' },
  ],
  U: [
    { id: 'uri-mauch', name: 'Uri Mauch' },
  ],
  V: [
    { id: 'vinicius-junior', name: 'Vinicius Junior' },
    { id: 'virgil-van-dijk', name: 'Virgil van Dijk' },
    { id: 'victor-osimhen', name: 'Victor Osimhen' },
  ],
  W: [
    { id: 'william-saliba', name: 'William Saliba' },
    { id: 'wout-weghorst', name: 'Wout Weghorst' },
    { id: 'wataru-endo', name: 'Wataru Endo' },
  ],
  X: [
    { id: 'xavi-hernandez', name: 'Xavi Hernandez' },
    { id: 'xavi-simons', name: 'Xavi Simons' },
  ],
  Y: [
    { id: 'youri-tielemans', name: 'Youri Tielemans' },
    { id: 'yannick-carrasco', name: 'Yannick Carrasco' },
  ],
  Z: [
    { id: 'zlatan-ibrahimovic', name: 'Zlatan Ibrahimovic' },
    { id: 'zinedine-zidane', name: 'Zinedine Zidane' },
  ],
}
